import React, { useId } from 'react'
import clsx from 'clsx'

export function Logomark({
  invert = false,
  filled = false,
  ...props
}: React.ComponentPropsWithoutRef<'svg'> & {
  invert?: boolean
  filled?: boolean
}) {
  let id = useId()

  return (
    <svg viewBox="0 0 240.116 94.3799" aria-hidden="true" {...props}>
      <rect
          clipPath={`url(#${id}-clip)`}
          className={clsx(
            'h-full transition-all duration-300',
            invert ? 'fill-white' : 'fill-neutral-950',
            filled ? 'w-full' : 'w-0 group-hover/logo:w-full',
          )}
        />
        <use
          href={`#${id}-path`}
          className={invert ? 'stroke-white' : 'stroke-neutral-950'}
          fill="none"
          strokeWidth="1.25"
        />
        <defs>
          <g id={`${id}-path`}>
            <path
              id="open_less_than"
              transform="translate(0,-21.73072)"
              d="M31.83 30.71 L0 62.55 L31.83 94.38 L33.52 92.69 L3.37 62.55 L33.52 32.4 L31.83 30.71 Z"
            />
            <path
              id="laptop_monitor"
              transform="translate(52.9114,-27.3268)"
              d="M90.38 85.63 L8.75 85.63 L8.75 36.07 L90.38 36.07 L90.38 85.63 ZM99.12 33.16 C99.12 29.95 96.5 27.33
                                 93.29 27.33 L5.83 27.33 C2.62 27.33 0 29.95 0 33.16 L0 94.38 L99.12 94.38 L99.12 33.16 Z"
            />
            <path
              id="laptop_keyboard"
              transform="translate(35.4193,-12.73463)"
              d="M75.8 85.63 L75.8 87.09 C75.8 87.97 75.22 88.55 74.34 88.55 L59.76 88.55 C58.89 88.55 58.31 87.97 58.31
                                 87.09 L58.31 85.63 L0 85.63 L0 88.55 C0 91.76 2.62 94.38 5.83 94.38 L128.28 94.38 C131.48 94.38
                                 134.11 91.76 134.11 88.55 L134.11 85.63 L75.8 85.63 Z"
            />
            <path
              id="close_greater_than"
              transform="translate(193.8464,-21.80819)"
              d="M0 32.4 L30.15 62.55 L0 92.69 L1.69 94.38 L33.52 62.55 L1.69 30.71 L0 32.4 Z"
            />
            <path
              id="close_slash"
              transform="translate(82.175,50.61337) rotate(-75)"
              d="M0 94.38 L70.87 94.38"
              strokeWidth="2.25"
            />
            <path
              id="cloud"
              transform="translate(67.0395,-40.3088)"
              d="M60.97 74.33 C60.72 74.33 60.39 74.33 60.14 74.33 C60.14 74.33 60.14 74.33 60.14 74.33 C60.14 70.26 58.14
                             66.52 54.9 64.19 C51.57 61.86 47.33 61.28 43.5 62.61 C40.34 56.45 33.35 53.29 26.7 54.87 C20.05 56.45
                             15.22 62.44 15.22 69.34 C15.22 69.34 15.22 69.43 15.22 69.51 C10.65 68.76 6.07 70.67 3.24 74.33 C0.5
                             78.08 0 82.98 1.91 87.14 C3.91 91.3 8.07 94.05 12.64 94.3 L12.64 94.38 L60.88 94.38 C66.37 94.38 70.87
                             89.89 70.87 84.4 C70.87 78.91 66.46 74.33 60.97 74.33 Z"
            />
          </g>
          <clipPath id={`${id}-clip`}>
            <use href="#open_less_than" />
            <use href="#laptop_monitor" />
            <use href="#laptop_keyboard" />
            <use href="#close_greater_than" />
            <use href="#close_slash" />
            <use href="#cloud" />
          </clipPath>
        </defs>
      </svg>
  )
}

export function Logo({
                       className,
                       invert = false,
                       filled = false,
                       fillOnHover = false,
                       ...props
                     }: React.ComponentPropsWithoutRef<'svg'> & {
  invert?: boolean
  filled?: boolean
  fillOnHover?: boolean
}) {
  return (
      <svg
          viewBox="0 0 130 32"
          aria-hidden="true"
          className={clsx(fillOnHover && 'group/logo', className)}
          {...props}
      >
        <Logomark
            preserveAspectRatio="xMinYMid meet"
            invert={invert}
            filled={filled}
        />
      </svg>
  )
}
